import React from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';
import { SecondaryButton, PrimaryButton, StickyModalActions } from '@/styles/blocks';
import { OnwardCheckbox } from '../../../blocks';

/**
 * Cancel, the "Save Customer" box (unsaved orders only), and Done.
 *
 * @param {object} props
 * @param {boolean} props.saveInflight True while the Done sequence runs. Disables both buttons.
 * @param {boolean} props.isNewOrder Shows the "Save Customer" box.
 * @param {boolean} props.saveCustomer Whether the box is checked.
 * @param {(checked: boolean) => void} props.onSaveCustomerChange Called when the box changes.
 * @param {boolean} props.canSave True when the draft is valid and mileage settings have loaded.
 * @param {boolean} props.saveBlocked True when saving must wait: read-only, or a live change to reload.
 * @param {boolean} [props.checking] True while the open-time re-sync runs. Done waits with its spinner;
 * Cancel stays enabled.
 * @param {() => void} props.onSave Runs the Done sequence.
 * @param {() => void} props.onCancel Closes the modal.
 */
const ModalFooter = ({
    saveInflight,
    isNewOrder,
    saveCustomer,
    onSaveCustomerChange,
    canSave,
    saveBlocked,
    checking,
    onSave,
    onCancel,
}) => (
    <StickyModalActions border="true">
        <Grid>
            <SecondaryButton disabled={saveInflight} onClick={onCancel}>
                Cancel
            </SecondaryButton>
        </Grid>
        <Grid>
            {isNewOrder && (
                <OnwardCheckbox
                    css={css`
                        padding-right: 20px;
                    `}
                    checked={saveCustomer}
                    onChange={(e) => {
                        onSaveCustomerChange(e.target.checked);
                    }}
                    label="Save Customer"
                />
            )}
            {canSave ? (
                <PrimaryButton
                    loading={saveInflight || checking}
                    disabled={saveInflight || saveBlocked || checking}
                    onClick={onSave}
                >
                    Done
                </PrimaryButton>
            ) : (
                <PrimaryButton loading={checking} disabled={true}>
                    Done
                </PrimaryButton>
            )}
        </Grid>
    </StickyModalActions>
);

export default ModalFooter;
